<template>
  <v-container
    id="world-games-list"
    tag="section"
  >
    <!-- Bouton de retour vers la liste des mondes -->
    <v-row>
      <v-btn
        text
        @click="routeToWorldsList()"
      >
        <v-icon left>
          mdi-chevron-left
        </v-icon>
        Retour
      </v-btn>
    </v-row>

    <!-- Toast de réussite ou d'échec -->
    <!--<v-snackbar
      v-model="msg.alert"
      top
      shaped
      :color="msg.type"
      :timeout="msg.timeout"
    >
      <v-icon left>
        {{ msg.icon }}
      </v-icon>
      {{ msg.msg }}

      <template v-slot:action="{ attrs }">
        <v-btn
          dark
          text
          v-bind="attrs"
          @click="msg.alert = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>-->
    <v-row justify="center">
      <v-col cols="8">
        <timed-alert
          :display="msg.alert"
          :msg="msg.msg"
          :type="msg.type"
        />
      </v-col>
    </v-row>

    <base-material-card
      color="primary"
      icon="mdi-briefcase-variant"
      inline
      class="px-5 py-3"
    >
      <template v-slot:heading>
        <div class="display-2 font-weight-light">
          <v-icon left>
            mdi-book-open-page-variant
          </v-icon>
          {{ title }}
        </div>
      </template>

      <!-- **************** ***
      ****      MODALS      ***
      **** **************** -->
      <!-- Modal de création de jeu -->
      <template v-slot:after-heading>
        <v-dialog
          v-model="addDialog"
          max-width="500px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              dark
              outlined
              class="mb-2"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon left>
                mdi-plus
              </v-icon>
              Ajouter un jeu
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline secondary--text">Nouveau jeu</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <!-- Formulaire -->
                <v-form
                  ref="addForm"
                  v-model="addIsValid"
                >
                  <v-row>
                    <v-col cols="12">
                      <v-select
                        v-model="addedItem.gameTypeId"
                        :items="types"
                        label="Type..."
                        :rules="[rules.required]"
                        prepend-icon="mdi-gamepad-square"
                      />
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="addedItem.title"
                        :rules="[rules.required]"
                        label="Titre..."
                        counter="250"
                        prepend-icon="mdi-book-open-page-variant"
                      />
                    </v-col>
                    <v-col cols="12">
                      <v-textarea
                        v-model="addedItem.description"
                        auto-grow
                        :rules="[rules.required]"
                        rows="7"
                        label="Description..."
                        prepend-icon="mdi-clipboard-text-multiple"
                      />
                    </v-col>
                    <v-col cols="12">
                      <v-select
                        v-model="addedItem.answer"
                        :items="answers"
                        label="Reponse dans le cas d'un quizz..."
                        prepend-icon="mdi-comment-question-outline"
                      />
                    </v-col>
                  </v-row>
                </v-form>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer />
              <v-btn
                color="success darken-1"
                text
                :disabled="!addIsValid"
                @click="addItem()"
              >
                Créer
              </v-btn>
              <v-btn
                color="error darken-1"
                text
                @click="addDialog = false"
              >
                Annuler
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>

      <!-- Modal de modification de jeu -->
      <v-dialog
        v-model="editDialog"
        persistent
        max-width="500px"
      >
        <v-card>
          <v-card-title>
            <span class="headline secondary--text">Modification du jeu<br><b>{{ editedItem.title }}</b></span>
          </v-card-title>

          <v-card-text>
            <v-container>
              <!-- Formulaire -->
              <v-form
                ref="editForm"
                v-model="editIsValid"
              >
                <v-row>
                  <v-col cols="12">
                    <v-select
                      v-model="editedItem.gameTypeId"
                      :items="types"
                      label="Type..."
                      :rules="[rules.required]"
                      prepend-icon="mdi-gamepad-square"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="editedItem.title"
                      :rules="[rules.required]"
                      label="Titre..."
                      counter="250"
                      prepend-icon="mdi-book-open-page-variant"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-textarea
                      v-model="editedItem.description"
                      auto-grow
                      :rules="[rules.required]"
                      rows="7"
                      label="Description..."
                      prepend-icon="mdi-clipboard-text-multiple"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-select
                      v-model="editedItem.answer"
                      :items="answers"
                      label="Reponse dans le cas d'un quizz..."
                      prepend-icon="mdi-comment-question-outline"
                    />
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer />
            <v-btn
              color="success darken-1"
              text
              :disabled="!editIsValid"
              @click="editItem()"
            >
              Modifier
            </v-btn>
            <v-btn
              color="error darken-1"
              text
              @click="editDialog = false"
            >
              Annuler
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Modal de suppression de jeu -->
      <v-dialog
        v-model="deleteDialog"
        persistent
        max-width="500px"
      >
        <v-card>
          <v-card-title class="headline">
            Êtes-vous sûr de vouloir<br>supprimer Le jeu
            <div class="container">
              <span class="secondary--text">
                <b>{{ deletedItem.title }}</b>
              </span>
              ?
            </div>
          </v-card-title>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="success darken-1"
              text
              @click="deleteItem()"
            >
              Supprimer
            </v-btn>
            <v-btn
              color="error darken-1"
              text
              @click="deleteDialog = false"
            >
              Annuler
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- **************** ***
      ****      TABLE      ***
      **** **************** -->
      <!-- Champ de recherche dans la table -->
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        class="ml-auto"
        label="Rechercher"
        hide-details
        single-line
        style="max-width: 250px;"
      />

      <v-divider class="mt-3" />

      <v-data-table
        :headers="headers"
        :items="items"
        :search.sync="search"
        :sort-by="['position']"
        :sort-desc="[false]"
        :loading="isLoading"
        :items-per-page="Number(20)"
        multi-sort
      >
        <template v-slot:body="props">
          <draggable
            v-model="props.items"
            tag="tbody"
            @change="handleDragChange(props.items, idWorld)"
          >
            <!-- Description d'une ligne -->
            <tr
              v-for="(item, index) in props.items"
              :key="index"
            >
              <td>
                <!-- Affichage de l'icône de drag and drop -->
                <v-row justify="center">
                  <v-icon>
                    mdi-sort-variant
                  </v-icon>
                </v-row>
              </td>
              <td> {{ item.id }} </td>
              <td> {{ item.title }} </td>
              <td> {{ item.description }} </td>
              <td> {{ item.gametype }} </td>
              <td> {{ item.answerclaire }} </td>
              <td> {{ item.position }} </td>
              <td>
                <!-- Définition de l'action d'édition -->
                <v-row justify="center">
                  <v-icon
                    class="success--text"
                    @click="prepareEditItem(item, 0)"
                  >
                    mdi-pencil
                  </v-icon>
                </v-row>
              </td>
              <td>
                <!-- Définition de l'action de suppression -->
                <v-row justify="center">
                  <v-icon
                    class="error--text"
                    @click="prepareDeleteItem(item)"
                  >
                    mdi-delete
                  </v-icon>
                </v-row>
              </td>
            </tr>
          </draggable>
        </template>
      </v-data-table>
    </base-material-card>
  </v-container>
</template>

<script>
  /* Les composants et packages dont on a besoin */
  import TimedAlert from '../alerts/TimedAlert.vue'
  import Draggable from 'vuedraggable'

  /* Rend le composant accessible aux autres composants */
  export default {
    /* Nom du composant */
    name: 'WorldGamesList',

    /* Sous-composants utilisés par ce composant */
    components: {
      TimedAlert,
      Draggable,
    },

    /* Paramètres */
    props: {
      idWorld: {
        type: String,
        default: undefined,
      },
      nameWorld: {
        type: String,
        default: undefined,
      },
    },

    /* Variables internes
     * data doit être une fonction si ce composant est utilisé dans un autre composant */
    data: () => ({
      isLoading: true,

      // Variables pour les formulaires de création / modification / suppression
      rules: {
        required: value => !!value || 'Ce champ ne peut être vide.',
      },

      types: [
        {
          value: 1,
          text: 'Quizz',
        },
        {
          value: 2,
          text: 'Challenge',
        },
      ],

      answers: [
        {
          value: 0,
          text: 'Faux',
        },
        {
          value: 1,
          text: 'Vrai',
        },
      ],
      addDialog: false,
      addIsValid: true,
      addedItem: {
        type: undefined,
        text: undefined,
        source: undefined,
      },

      editDialog: false,
      editIsValid: true,
      editedItem: {
        id: undefined,
        worldId: undefined,
        type: undefined,
        text: undefined,
        source: undefined,
      },

      deleteDialog: false,
      deletedItem: {
        id: undefined,
      },

      // Message de réussite ou d'échec des actions
      msg: {
        alert: false,
        msg: '',
        timeout: 5000,
        type: 'success',
      },

      // Variables relatives au tableau de données
      headers: [
        {
          sortable: false,
          value: 'drag',
        },
        {
          text: '#',
          value: 'id',
        },
        {
          text: 'Title',
          value: 'title',
        },

        {
          text: 'Description',
          value: 'description',
        },
        {
          text: 'Type',
          value: 'gametype',
        },
        {
          text: 'Réponse',
          value: 'answerclaire',
        },
        {
          text: 'Position',
          value: 'position',
        },
        {
          sortable: false,
          text: 'Éditer',
          value: 'edit',
        },
        {
          sortable: false,
          text: 'Supprimer',
          value: 'delete',
        },
      ],
      items: [],
      search: undefined,
    }),

    /* Variables internes dynamiques
     * (MAJ automatique quand les variables qu'elles utilisent sont mises à jour) */
    computed: {
      title: function () {
        return 'Jeux ' +
          (this.isVowelIndex(this.nameWorld[0]) ? 'd\'' : 'de ') +
          this.nameWorld
      },
    },

    /* Hook : fonction appelée juste après que l’instance ait été montée */
    mounted: function () {
      this.fetchGames(this.idWorld)
    },

    /* Fonctions internes */
    methods: {

      // Modification de la position par drag & drop
      handleDragChange: function (items, idWorld) {
        // On définie l'état en chargement
        this.isLoading = true
        items.map((item, index) => {
          // Mettre à jour uniquement les positions impactées
          const newPosition = index + 1
          if (item.position !== newPosition) {
            item.position = newPosition
            this.$Auth.httpRequest('post', 'api/game/updatePosition', {
              position: newPosition,
              worldId: idWorld,
              gameId: item.id,
            })
              .catch((/* error */) => {
                // Affichage de l'erreur
                this.setMsgError('Erreur lors de la modification de la position du jeu ' + item.id)
                if (this.$Auth.isAdmin()) {
                // console.log('Error in ' + this.$options.name + ' : ', error)
                }
              })
              .finally(() => {
                this.isLoading = false
                this.fetchGames(this.idWorld)
              })
          }
        })
      },

      // State if the char is a vowel
      isVowelIndex: function (char) {
        const vowelsIndex = 'aeiouyAEIOUY'
        if (char.length === 1) {
          return vowelsIndex.indexOf(char) >= 0
        }
      },

      // Récupération des données de toutes les jeux du monde
      fetchGames: function (idWorld) {
        if (!this.idWorld) {
          this.items = []
          return
        }
        this.$Auth.httpRequest(
          'get',
          'api/game/selectAll?worldId=' + idWorld,
        )
          .then(datas => {
            if (Array.isArray(datas.data) || datas.data.length > 0) {
              this.items = datas.data
            } else {
              this.items = []
            }
          })
          .catch((/* error */) => {
            this.setMsgError('Une erreur est survenue lors de la récupération de la liste des jeux.')
            if (this.$Auth.isAdmin()) {
              // console.log('Error in ' + this.$options.name + ' : ', error)
            }
          })
          .finally(() => {
            this.isLoading = false
          })
      },

      // Route vers la page de la liste des mondes
      routeToWorldsList: function () {
        this.$router.push({ name: 'Worlds List' })
      },

      /* ********************************* **
      /** Fonctions relatives aux messages **
      /** ******************************** */
      /* Setter de message de réussite */
      setMsgSuccess: function (msg) {
        this.msg.msg = msg
        this.msg.alert = true
        this.msg.type = 'success'
        this.msg.icon = 'mdi-checkbox-marked-circle-outline'
      },

      /* Setter de message d'échec */
      setMsgError: function (msg) {
        this.msg.msg = msg
        this.msg.alert = true
        this.msg.type = 'error'
        this.msg.icon = 'mdi-error-outline'
      },

      /* ******************************* **
      /** Fonctions d'ajout de jeu **
      /** ****************************** */
      addItem: function () {
        // On définie l'état en chargement
        this.isLoading = true
        this.addDialog = false
        this.msg.alert = false

        // Ajout d'une jeu
        this.$Auth.httpRequest('post', 'api/game/insert', {
          worldId: this.idWorld,
          gameTypeId: this.addedItem.gameTypeId,
          title: this.addedItem.title,
          description: this.addedItem.description,
          answer: this.addedItem.answer,
        })
          .then(datas => {
            // Affichage de la confirmation
            this.setMsgSuccess('Le jeu a été ajouté avec succès.')

            // Réinitialisation des valeurs pour l'item ajouté
            this.addedItem.gameTypeId = undefined
            this.addedItem.title = undefined
            this.addedItem.description = undefined
            this.addedItem.description = undefined
            this.addedItem.answer = undefined
            this.addedItem.position = undefined
          })
          .catch((/* error */) => {
            // Affichage de l'erreur
            this.setMsgError('Une erreur est survenue lors de l\'ajout du jeu.')
            if (this.$Auth.isAdmin()) {
              // console.log('Error in ' + this.$options.name + ' : ', error)
            }
          })
          .finally(() => {
            this.$refs.addForm.resetValidation()
            this.isLoading = false
            this.fetchGames(this.idWorld)
          })
      },

      /* *************************************** **
      /** Fonctions de modification de jeu **
      /** ************************************** */
      prepareEditItem: function (item, tab) {
        // Création du clone d'item
        this.editedItem = { ...item }
        this.editDialog = true
      },

      resetEditedItem: function () {
        return {
          id: undefined,
          worldId: undefined,
          type: undefined,
          title: undefined,
          source: undefined,
          position: undefined,
          positionSist: undefined,
        }
      },

      editItem: function () {
        // On définie l'état en chargement
        this.isLoading = true
        this.editDialog = false
        this.msg.alert = false

        // Modification du jeu
        this.$Auth.httpRequest('post', 'api/game/update', {
          title: this.editedItem.title,
          description: this.editedItem.description,
          gameTypeId: this.editedItem.gameTypeId,
          gameId: this.editedItem.id,
          worldId: this.idWorld,
          answer: this.editedItem.answer,
        })
          .then(datas => {
            // Affichage de la confirmation
            this.setMsgSuccess('Le jeu a été modifié avec succès.')
          })
          .catch((/* error */) => {
            // Affichage de l'erreur
            this.setMsgError('Une erreur est survenue lors de la modification du jeu.')
            if (this.$Auth.isAdmin()) {
              // console.log('Error in ' + this.$options.name + ' : ', error)
            }
          })
          .finally(() => {
            this.$refs.editForm.reset()
            this.editedItem = this.resetEditedItem()
            this.isLoading = false
            this.fetchGames(this.idWorld)
          })
      },

      /* ************************************** **
      /** Fonctions de suppression de jeu **
      /** ************************************* */
      prepareDeleteItem: function (item) {
        // Création du clone d'item
        this.deletedItem = { ...item }
        this.deleteDialog = true
      },

      deleteItem: function () {
        // On définie l'état en chargement
        this.isLoading = true
        this.deleteDialog = false
        this.msg.alert = false

        //  Suppression du jeu
        this.$Auth.httpRequest(
          'delete',
          'api/game/delete?id=' + this.deletedItem.id,
        )
          .then(datas => {
            // Affichage de la confirmation
            this.setMsgSuccess('Le jeu a été supprimé avec succès.')
          })
          .catch((/* error */) => {
            // Affichage de l'erreur
            this.setMsgError('Une erreur est survenue lors de la suppression du jeu.')
            if (this.$Auth.isAdmin()) {
              // console.log('Error in ' + this.$options.name + ' : ', error)
            }
          })
          .finally(() => {
            this.isLoading = false
            this.fetchGames(this.idWorld)
          })
      },
    },
  }
</script>
